import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import direitoPenal from 'assets/images/direito-penal.jpg'
import direitoCivil from 'assets/images/direito-civil.jpg'
import direitoTrabalhista from 'assets/images/direito-trabalhista.jpg'
import direitoEmpresarial from 'assets/images/direito-empresarial.jpg'
import direitoTributario from 'assets/images/direito-tributario.jpg'
import direitoFamiliar from 'assets/images/direito-familiar.jpg'
import recuperacaoCredito from 'assets/images/recuperacao-credito.jpg'
import Header from 'components/Header'
import Footer from 'components/Footer'

const ServiceDetails = () => {
  const { serviceName } = useParams()

  const data = [
    {
      name: 'Direito Tributário',
      image: direitoTributario,
      description:
        'O Direito Tributário é o ramo do direito que cuida das relações jurídicas entre o fisco e os contribuintes. Envolve impostos, taxas e contribuições, além de normas que regulam sua arrecadação e fiscalização.',
    },
    {
      name: 'Direito Empresarial',
      image: direitoEmpresarial,
      description:
        'O Direito Empresarial regula as atividades empresariais, abordando desde a constituição de empresas até falências, passando pela organização societária, contratos empresariais e propriedade intelectual.',
    },
    {
      name: 'Recuperação de Crédito',
      image: recuperacaoCredito,
      description:
        'A Recuperação de Crédito é o conjunto de medidas legais para garantir o recebimento de créditos inadimplidos. Inclui desde a cobrança judicial até acordos extrajudiciais para recuperar valores devidos.',
    },
    {
      name: 'Direito Penal',
      image: direitoPenal,
      description:
        'O Direito Penal é a área do direito que estabelece e regula as penas aplicáveis aos delitos cometidos, buscando a proteção da sociedade e a ressocialização do indivíduo. Envolve crimes, penas e medidas de segurança.',
    },
    {
      name: 'Direito Civil',
      image: direitoCivil,
      description:
        'O Direito Civil regula as relações entre os indivíduos, abordando desde contratos até questões familiares como casamento, divórcio, guarda de filhos e direitos sucessórios.',
    },
    {
      name: 'Direito da Família',
      image: direitoFamiliar,
      description:
        'O Direito da Família trata das relações familiares e questões como casamento, divórcio, guarda de filhos, alimentos e adoção, buscando proteger os direitos dos membros da família e a harmonia no convívio.',
    },
    {
      name: 'Direito Trabalhista',
      image: direitoTrabalhista,
      description:
        'O Direito Trabalhista regula as relações entre empregadores e empregados, garantindo direitos e deveres de ambos, como salário mínimo, jornada de trabalho, férias, segurança no trabalho e direitos sindicais.',
    },
  ]

  const normalizeString = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .toLowerCase()
  }

  const normalizedServiceName = normalizeString(serviceName)

  const service = data.find((item) => normalizeString(item.name) === normalizedServiceName)

  if (!service) {
    return <div>Serviço não encontrado.</div>
  }

  useEffect(() => {
    document.title = `Macias & Cruz - ${service.name}`
    window.scrollTo(0, 0)
  }, [serviceName])

  return (
    <main className='flex min-h-screen flex-col items-center justify-center'>
      <Header />
      <div className='mb-20 mt-28 grid w-11/12 grid-cols-1 items-center gap-4 md:w-9/12 md:grid-cols-2 md:gap-8'>
        <div className='md:col-span-1'>
          <img src={service.image} alt={service.name} className='w-full' />
        </div>
        <div className='flex flex-col items-start gap-4 md:col-span-1'>
          <h1 className='text-2xl font-bold uppercase md:text-5xl'>{service.name}</h1>
          <p className='text-gray-700 text-justify text-base md:text-xl'>{service.description}</p>
          <a
            href='https://api.whatsapp.com/send?phone=554398255439&text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consultoria'
            target='_blank'
            className='md: rounded-xl bg-golden p-3 text-base font-medium uppercase transition-all duration-300 hover:opacity-75'
          >
            Agendar Consultoria
          </a>
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default ServiceDetails
